import axios from 'axios';

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

export const mailPreferencesAPI = {
  getPreferences: async () => {
    const { data } = await api.get('/mail-subscription');
    return data;
  },

  updatePreferences: async (settings) => {
    const { data } = await api.post('/mail-subscription', settings);
    return data;
  },

  disableSubscription: async () => {
    const { data } = await api.delete('/mail-subscription');
    return data;
  },
};
